import React from 'react';

const TestDescription = ({ description, bulletPoints = [] }) => {
  return (
    <div className="p-4 border-t border-gray-200">
      <h3 className="text-lg font-medium mb-3">Description</h3>
      <p className="text-gray-700 mb-3">{description}</p>
      
      {bulletPoints.length > 0 && (
        <ul className="list-disc pl-5 text-gray-700 space-y-1">
          {bulletPoints.map((point, index) => (
            <li key={index}>{point}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TestDescription;
